var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-patient',{attrs:{"ifShow":_vm.ifShow,"ifSave":_vm.ifSave},on:{"cancel":_vm.cancel,"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }